import { CountryCode, Option } from '../pages/types';

export const COUNTRY_OPTIONS: Option[] = [
  { value: CountryCode.US, label: `🇺🇸 ${CountryCode.US}` },
  { value: CountryCode.CA, label: `🇨🇦 ${CountryCode.CA}` },
];

const labelToSlug = (label: string): string =>
  label
    .toLowerCase()
    .replace(/\([^)]*\)/g, '')
    .replace(/[^a-z\s]/g, '')
    .trim()
    .replace(/\s+/g, '_');

export const isValidPostCheckoutSurveyOptionLabel = (label: string): boolean =>
  Boolean(labelToSlug(label));

export const generatePostCheckoutSurveyOptionValue = (
  label: string,
  country: CountryCode
): string => {
  const suffix = country === CountryCode.CA ? '_can' : '_us';
  const slug = labelToSlug(label);
  if (!slug) {
    throw new Error('Label must contain at least one alphanumeric character');
  }
  return `${slug}${suffix}`;
};
